import Axios from "axios";
import {  ChequesFilter, GetChequeInfoReportRequest, GetChequeInfoReportResponse } from "../models/chequeInfoReport.model";
import { ApiResultModel } from "../models/common.model";
import { ApiBaseUrl, ReportChequeURL } from "../config/config";

export const GetChequeInfoReport = async (
  data: GetChequeInfoReportRequest
): Promise<ApiResultModel<GetChequeInfoReportResponse[]>> => {
  return await Axios.post<ApiResultModel<GetChequeInfoReportResponse[]>>(
    ApiBaseUrl + ReportChequeURL + "/GetChequeInfoReport",
    data
  ).then((result) => {
    return result.data;
  });
};

export const ExportChequeInfo = async (  data: ChequesFilter
) => {
  return await Axios({
    method: "POST",
    url:ApiBaseUrl + ReportChequeURL + "/ExportChequeInfo",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `${"جدول اطلاعات چک"}.xlsx`
    );
    document.body.appendChild(link);
    link.click();
  });
};

